import CheckNewRequestModifyPage from "../../shared/checkNewRequest/CheckNewRequestModifyPage";
import { CHECK_NEW_REQUEST_CONFIG } from "../../shared/checkNewRequest/checkNewRequestConfig";

const ManagementCheckNewRequestModifyPage = () => (
  <CheckNewRequestModifyPage config={CHECK_NEW_REQUEST_CONFIG.management} />
);

export default ManagementCheckNewRequestModifyPage;
